import styled, { css } from 'styled-components';

export const ExtoleIframe = styled.iframe`
  ${({ theme }) => css`
    width: 100%;
    min-height: 610px;
    border: none;
    display: block;
    overflow: hidden;
    // Note: This is necessary because extole iframe is a cross origin iframe that dont share with us the height of the iframe, so we need to set the height manually for each breakpoint.
    @media (max-width: ${theme.v3.breakpoints.lg}) {
      min-height: 670px;
    }
    @media (max-width: 800px) {
      min-height: 640px;
    }
    @media (max-width: 670px) {
      min-height: 600px;
    }
    @media (max-width: 640px) {
      min-height: 680px;
    }
    @media (max-width: 470px) {
      min-height: 785px;
    }
    @media (max-width: 390px) {
      min-height: 800px;
    }
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-left: 48px;
  padding-right: 48px;
`;
